// src/main/frontend/src/context/ReviewContext.jsx
import React, { createContext, useState, useContext } from 'react';

const ReviewContext = createContext();

export const ReviewProvider = ({ children }) => {
    const [reviewsUpdated, setReviewsUpdated] = useState(false);

    const notifyReviewUpdate = () => {
        setReviewsUpdated(prev => !prev); // 토글하여 변경 감지
    };

    return (
        <ReviewContext.Provider value={{ reviewsUpdated, notifyReviewUpdate }}>
            {children}
        </ReviewContext.Provider>
    );
};

export const useReviewContext = () => useContext(ReviewContext);
